export const USER_ROLES = [
  {
    label: "Councilor",
    value: "Councilor",
  },
  {
    label: "Admin user 1",
    value: "Admin user 1",
  },
  {
    label: "Admin user 2",
    value: "Admin user 2",
  },
];

export const USER_TYPE = [
  {
    label: "CSD User",
    value: 1,
  },
  {
    label: "Active directory user",
    value: 2,
  },
];
